module.exports = __webpack_public_path__ + "static/media/wide.1515d5bc.jpg";